import { AlertCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background" data-testid="page-404">
      <div className="text-center max-w-md px-6">
        <div className="w-16 h-16 rounded-2xl bg-foreground/[0.04] border border-foreground/[0.08] flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="h-8 w-8 text-foreground/20" />
        </div>
        <h1 className="text-4xl font-display font-bold text-foreground mb-2" data-testid="text-404-title">404</h1>
        <p className="text-sm text-foreground/40 mb-8" data-testid="text-404-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link href="/">
          <Button variant="outline" className="gap-2" data-testid="button-back-home">
            <ArrowLeft size={14} />
            Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
